import { createModel } from "@rematch/core";
import { CustomerType, EffectFilterState } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: EffectFilterState = {
  customerType: CustomerType.PK,
};

export const effectsFilter = createModel<RootModel>()({
  state: initialState as EffectFilterState,
  reducers: {
    fetchColumnsSuccess(
      state: EffectFilterState,
      payload: Array<{ columnName: string; columns: string[] }>
    ) {
      if (
        payload
          .map((columnData) => columnData.columnName)
          .includes(state.columnName || "")
      ) {
        return state;
      } else {
        return {
          ...state,
          columnName: payload.length > 0 ? payload[0].columnName : undefined,
        };
      }
    },
    fetchColumnsFail(state) {
      return { ...state };
    },
    changeEffectsFilter(
      state: EffectFilterState,
      payload: Partial<EffectFilterState>
    ) {
      return { ...state, ...payload };
    },
  },
  effects: (dispatch) => ({
    async fetchColumns(customerType: CustomerType, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.effectsFilter.fetchColumnsFail()
      );
      if (!token) return;

      try {
        const columnsResult = await api.fetchEffectsColumns(
          token,
          customerType
        );
        dispatch.effectsFilter.fetchColumnsSuccess(columnsResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.effectsFilter.fetchColumnsFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/effectsFilter.ts